/**
 * Validation utilities
 * @file
 */

// *****************************************************************************
// Validation and Submit
// 
// *****************************************************************************
export function ValidateAndSubmit(evt) {

   // Ascend from the button that triggered this click event until we find a container
   // element flagged with both 'validationGroup' and the group specific class.
   // Store a reference to that element.
   var groupName = getClass($(this), 'cvg_');
   var $group = $(evt.currentTarget).parents('.validationGroup.' + groupName);
   var isValid = true;

   isValid = ValidateGroup($group, groupName);

   // if any fields failed validation, prevent the button's click event from 
   // triggering form submission.
   if (!isValid)
      evt.preventDefault();
}

export function ValidateGroup(group, groupName) {
   var isValid = true;

   // set final check flag
   $('#form1').validationEngine('finalCheckFlag', true);

   // Descending from that 'validationGroup' element, find any input elements within
   // it, iterate over them, and run validation on each of them.
   group.find(':input.' + groupName)
      .not(':input[type=button], :input[type=submit], :input[type=reset]')
      .each(function (i, item) {
         if ($(item).validationEngine('validate'))
            isValid = false;
      });

   if (!isValid) {
      // "show" the error summary - for ADA reader
      $('#form1').validationEngine('showSRSummary');

      firstErrorFieldId = $('#form1').validationEngine('getFirstErrorFieldId');
      if (firstErrorFieldId) {
         $("input[id*='" + firstErrorFieldId + "']").focus();
      }
   }

   // set final check flag
   $('#form1').validationEngine('finalCheckFlag', false);

   return isValid;
}

// *****************************************************************************
// Zip Validation
//
// This zip validation functions are used when the page has the possibility
// of both domestic and international zip codes.
// 
// Assumptions:
//
// ******************************************************************************
export function ZipValidate(field, rules, i, options) {
   var errorMsg;
   var param = rules[i + 2];        // param holds id to country dropdown
   var countryType = $("select[id$='" + param + "']").val().toLowerCase();
   var inputText = field.val();

   if (countryType === 'us') {
      if (!options.allrules.zip.regex.test(inputText))
         errorMsg = options.allrules.zip.alertText;
   } else {
      if (!options.allrules.zipInternational.regex.test(inputText))
         errorMsg = options.allrules.zipInternational.alertText;
   }

   return errorMsg;
}

// *****************************************************************************
// Date Range Validation
//
// Validates whether or not the range between the start date and end date does 
// not exceed 12 months.
// 
// Assumptions:
//
// ******************************************************************************
export function DateRangeLimit(field, rules, i, options) {
   var errorMsg;
   var beginDateField = $('[id$="txtForbearanceBeginDate"]').val();
   var endDateField = $('[id$="txtForbearanceEndDate"]').val();

   if ((beginDateField != "") && (endDateField != "")) {
      var beginDate = new Date(beginDateField);
      var endDate = new Date(endDateField)
      var tempDate = new Date(+beginDate);
      tempDate.setDate(tempDate.getDate() + 365)
      if (endDate < beginDate) {
         errorMsg = "The begin date cannot be later than the end date.";
      }
      else {
         if (endDate > tempDate) {
            errorMsg = "The range between begin date and end date cannot exceed 12 months.";
         }
      }
   }
   else {
      if (endDateField === "") {
         errorMsg = "End date is required.";
      }
   }

   return errorMsg;
}

// *****************************************************************************
// Phone Validation
//
// These zip validation functions are used when the page has the possibility
// of both domestic and international phone numbers.
// 
// Assumptions:
//
// ******************************************************************************

function PhoneChecks(inputText, phoneType, options) {
   var errorMsg;
   var inputNoSpecialCharacters = removeSpecialCharacters(inputText);
   var phoneNumberSize = 14;        // phone number size = 10 digits + 4 digits of mask

   var areacode;
   var numbers;

   var sameCharacterCheck = options.allrules.sameCharacter.regex.test(inputNoSpecialCharacters);
   var validPhone = options.allrules.phone.regex.test(inputText);

   if (inputText.length > 0) {
      if (inputText.length != phoneNumberSize) {
         errorMsg = phoneType + " phone number must be 10 numeric digits";
         } 
         else if (sameCharacterCheck) {
         errorMsg = phoneType + " phone number may not be all the same digit";
         } 
         else if (!validPhone) {
         errorMsg = "Please enter a valid " + phoneType + " phone number";
         }
         // If number starts with 0 or 1
        else if (inputText.charAt(1) < "2") {
               errorMsg = "Number should not start with 0 or 1 "
            }
      // numbers after area code
        else if (phoneType === "Primary" || phoneType === "Work" || phoneType === "Alternate" || phoneType === "Text") {
         inputText = inputText.replace(/[^0-9]/g, '');
         areacode = inputText.substring(0, 3);
         numbers = inputText.substring(3);
         if (areacode !== "000") {
            if (numbers === "0000000" || numbers.substring(0, 3) === "000" )  {
               errorMsg = phoneType + " phone number is invalid "
               }
            if (numbers === "5551212") {
               errorMsg = " Please check the " +phoneType + " phone number. Must be a valid phone number "
               }
               }
            }
       }
      return errorMsg;
   }


export function PhoneDomesticValidate(field, rules, i, options) {
   var errorMsg;
   var inputText = field.val();
   var inputNoSpecialCharacters = removeSpecialCharacters(inputText);
   var phoneType = rules[i + 2];    // primary, alternate, or work
   var phoneNumberSize = 14;        // phone number size = 10 digits + 4 digits of mask

   var sameCharacterCheck = options.allrules.sameCharacter.regex.test(inputNoSpecialCharacters);
   var validPhone = options.allrules.phone.regex.test(inputText);

   // primary phone is the only required phone number
   if (phoneType === "Primary") {
      if ((inputText === undefined) || (inputText === "")) {
         errorMsg = "Primary phone number is required";
      } else {
         errorMsg = PhoneChecks(inputText, phoneType, options);
      }
   } else {
      errorMsg = PhoneChecks(inputText, phoneType, options);
   }

   return errorMsg;
}

export function PhoneValidate(field, rules, i, options) {
   var errorMsg;
   var inputText = field.val();
   var phoneType = rules[i + 2];

   if ((inputText === undefined) || (inputText === "")) {
      errorMsg = phoneType + " phone number is required";
   } else {
      errorMsg = PhoneChecks(inputText, phoneType, options);
   }

   return errorMsg;
}

 
// ----------------------------------------------------------
// Validate international phone number string`
//  strings are invalid if
//    any field is null
//    any field is not numeric.
// ----------------------------------------------------------
export function IsIntlValid(country, city, local) {
   if (country !== '') {
      country = removeSpecialCharacters(country);
   }
   if (city !== '') {
      city = removeSpecialCharacters(city);
   }
   if (local !== '') {
      local = removeSpecialCharacters(local);
   }
   if (country === '' && city === '' && local === '') {
      return true;
   } else {
      if (country === '' || city === '' || local === '') {
         return false;
      } else {
         return ($.isNumeric(country) && $.isNumeric(city) && $.isNumeric(local));
      }
   }
}

// *****************************************************************************
// Currency Validation
//
// If the input text is populated then validate it against the currency
// regular expression.  
// *****************************************************************************
function preprocessCurrency(amount) {
  amount = amount.replace('$', '');  // remove the dollar sign that the mask displays
  amount = amount.replace(/,/g, '');  // and the commas

  return amount;
}

export function currencyValidation(field, qualifiersPossible) {
  var inputText = field.val();
  var currencyRegExp;
  var isValid = true;

  if (qualifiersPossible) {
    inputText = preprocessCurrency(inputText);
    currencyRegExp = /^\s*\$?\s*\d{1,3}((,\d{3})*|\d*)(\.\d{2})\s*$/;
  } else {
    currencyRegExp = /^[0-9]+(\.[0-9]{2,2})$/;
  }


  if (inputText !== '') {
    isValid = currencyRegExp.test(inputText);
  }

  return isValid;
}

// *****************************************************************************
// Send Message Validation routines
//
// *****************************************************************************
function selectSubject(field, rules, i, options) {
   var error_msg;

   if (field[0].length > 1)
   {
      if ((field[0].value === "Select A Subject") )
      {
         return "Please select a Subject.";
      }
   }
   return error_msg;
}
// *****************************************************************************
// Bank Account Validation routines
//
// *****************************************************************************
export function selectBankAccount(field, rules, i, options) {
   var error_msg;

   if (field[0].length > 1) {             // if bank accounts exist
      if ((field.val() === undefined) || (field.val() === ""))
         error_msg = "Please select a Bank Account.";
   } else {                               // no banks accounts
      error_msg = "Please add a Bank Account.";
   }
   return error_msg;
}

export function validateSaveAccount() {
   var isValid = true;

   //hide_Error_Prompts();
   $('[id$="ddlBA"]').validationEngine('hide');

   var groupName = "cvg_AddBankAccount";
   var $group = $('[id$="divAddBA"]');

   isValid = ValidateGroup($group, groupName);

   return isValid;
}

// *****************************************************************************
// Payment Validation routines
//
// *****************************************************************************
export function validateOLPContinue() {
   var isValid = true;
   var groupName = "cvg_OLPContinue";
   var $group = $('[id$="divMain"]');

   if (validateSaveAccount() === true)
   {
      isValid = ValidateGroup($group, groupName);
   }
   else
   {
      isValid = false;
   }

   return isValid;
}

// *****************************************************************************
// Payoff Validation routines
//
// *****************************************************************************
function validatePayoffPayNow() {
   var isValid = true;
   var groupName = "cvg_CalculatePayoff";
   var $group = $('[id$="divLoansAvailable"]');

   isValid = ValidateGroup($group, groupName);

   return isValid;
}

// *****************************************************************************
// Meritize esign Validation routines
//
// *****************************************************************************
export function validateLNEFStep2() {
  var isValid = true; 

  var $checkBoxCheckedCount = $(".optionCheckBox input:checked").length;

  if ($checkBoxCheckedCount == 0) {
    isValid = false;
    $(".forbOptions").validationEngine('showPrompt', 'You have not chosen a reason for the forbearance.', 'error', 'topLeft', false);
    $('html, body').animate({ scrollTop: $(".forbOptions]").offset().top - 75 }, 125);
  } else if ($checkBoxCheckedCount > 1) {
    isValid = false;
    $(".forbOptions").validationEngine('showPrompt', 'You can only select one reason for forbearance.', 'error', 'topLeft', false);
    $('html, body').animate({ scrollTop: $(".forbOptions]").offset().top - 75 }, 125);
  } else {
    var groupName = "cvg_LNEForbStep2";
    var $group = $('[id$="pnlLNEForbStep2"]');

    var chkSchoolSuspensionChecked = $('[id$="chkSchoolSuspension"]').is(':checked');
    var chkSchoolClosedChecked = $('[id$="chkSchoolClosed"]').is(':checked');
    var chkFMLAChecked = $('[id$="chkFLMA"]').is(':checked');
    var chkIncomeReductionChecked = $('[id$="chkIncomeReduction"]').is(':checked');
    var chkUnemployedChecked = $('[id$="chkUnemployed"]').is(':checked');

    if (chkSchoolSuspensionChecked) {
      isValid = ValidateGroup($group, groupName);
    } else if (chkSchoolClosedChecked) {
      isValid = ValidateGroup($group, groupName);
    } else if (chkFMLAChecked || chkIncomeReductionChecked || chkUnemployedChecked) {
      isValid = true
    } else {
      isValid = false;
      $(".forbOptions").validationEngine('showPrompt', 'Invalid reason for forbearance.', 'error', 'topLeft', false);
      $('html, body').animate({ scrollTop: $(".forbOptions]").offset().top - 75 }, 125);
    }

  }
  return isValid
}


// *****************************************************************************
// Message Validation routines
//
// *****************************************************************************

export function validateSendMessage() {
   var isValid = true;

   var groupName = "cvg_SendMessage";
   var $group = $('[id$="pnlSendMessage"]');

   isValid = ValidateGroup($group, groupName);

   // ----------------------------------------------------------------
   // check if there is a query string in the URL
   // if so, check to see if the string contains the text "change"
   // if so, check to see if any files have been selected for upload
   // if NOT, flag an error as a file is required
   // ----------------------------------------------------------------
   var qs = window.location.search;
   if (qs.indexOf("change") != -1) {
      var uploadRows = $("table[id*='grd'] tr").length;
      if (uploadRows == 0) {
         $("[id*='divFileUpload']").validationEngine('showPrompt', 'At least one file must be uploaded.', 'error', 'topLeft', false);
         isValid = false;
      }
   }

   return isValid;
}

export function validateUploadFile() {
   var isValid = true;

   var groupName = "cvg_UploadFile";
   var $group = $('[id$="pnlUploadFile"]');

   isValid = ValidateGroup($group, groupName);

   var uploadRows = $("table.uploadlist tr").length;
   if (uploadRows == 0) {
      $("[id*='divFileUpload']").validationEngine('showPrompt', 'You must upload at least one document.', 'error', 'topLeft', false);
      isValid = false;
   }
   return isValid;
}



// revisit removal after applying ufc
export function validateUpLoadAttachments() {
   var isValid = true;

   var uploadRows = $("table.uploadlist tr").length;
   if (uploadRows == 0) {
      $(".button-container").validationEngine('hide');

      $(".button-container").validationEngine('showPrompt', 'You have not uploaded the required documentation.', 'error', 'topLeft', false);
      isValid = false;
   }

   return isValid;
}

function validateUpLoadAttachmentsAtLeastOne() {
   var isValid = true;

   var uploadRows = $("table[id*='dgAttachments'] tr").length;
   if (uploadRows == 1) {
      $("[id*='btnModify']").validationEngine('showPrompt', 'You can not remove all attached documents.  Use the Modify button to update your attachments', 'error', 'topLeft', false);
      isValid = false;
   }

   return isValid;
}

// *****************************************************************************
// Conditional Validation routines
//
// *****************************************************************************

function conditionalOLPPayAmount(field, rules, i, options) {
   var dependingField, error_msg, activeRegion;
   var param1 = rules[i + 2];   // param with depending field's id
   var param2 = rules[i + 3];       // param with active region or bypass flag

   // NA - case where we don't need to filter on active region and we want
   // to do the min/max checking below.  
   if (param2 === 'NA')
      activeRegion = 'NA';     // NA for the case we don't need to filter on active region below
   else
      activeRegion = $("[id$='" + param2 + "']")[0].innerHTML;
   //dependingField = $("input[id*='" + param1 + "']:checked");
   dependingField = field.closest("tr").find("input[id*='" + param1 + "']");

   if (dependingField.length) {
      if (dependingField.prop("checked")) {
         if ((field.val() === undefined) || (field.val() === "")) {
            error_msg = options.custom_error_messages['.valPaymentAmount']['required']['message'];
         } else if (!currencyValidation(field, true)) {
            error_msg = options.custom_error_messages['.valPaymentAmount']['mismatch']['message'];
         } else {
            if ((activeRegion === 'NA') || (activeRegion === 'F')) {
               var current = preprocessCurrency(field.val());
               current = parseFloat(current);
               if ((current < 5.00) || (current > 99999.99))
                  error_msg = options.custom_error_messages['.valPaymentAmount']['range']['message'];
            }
         }
      }
   }
   return error_msg;
}

// checkSpouse returns true if spousal information is required
function checkSpouse(taxFiling, separatedFromSpouse, reasonableAccess) {
   if ((taxFiling == "MJ") || (taxFiling == "MS")) {
      if ((separatedFromSpouse == "N") && (reasonableAccess == "Y"))
         return true;
   }
   
   return false;
}

function PriorYearAGI(field, rules, i, options) {
   var yr = rules[i + 2];
   var inputText = field.val();

   if ((inputText === undefined) || (inputText === "")) {
      return "AGI for tax year " + yr + " is required.";
   } else if (currencyValidation(field, true) === false) {
      return "The format of AGI for tax year " + yr + " is invalid.  Plese use the 0.00 format for currency amounts.";
   } else if (inputText < 0 || inputText > 500000) {
      return "AGI for tax year " + yr + " must be between 0.00 and 500,000.00";
   }
   return;
}

function PriorYearNumChildren(field, rules, i, options) {
   var yr = rules[i + 2];
   var inputText = field.val();

   if ((inputText === undefined) || (inputText === "")) {
      return "Number of Children for tax year " + yr + " is required.";
   } else if (isNaN(inputText)) {
      return "Number of Children for tax year " + yr + " must be numeric.";
   } else if (inputText < 0 || inputText > 25) {
      return "Number of Children for tax year " + yr + " must be between 0 and 25.";
   }
   return;
}

function PriorYearNumDependents(field, rules, i, options) {
   var yr = rules[i + 2];
   var inputText = field.val();

   if ((inputText === undefined) || (inputText === "")) {
      return "Number of others receiving half their support for tax year " + yr + " is required.";
   } else if (isNaN(inputText)) {
      return "Number of others receiving half their support for tax year " + yr + " must be numeric.";
   } else if (inputText < 0 || inputText > 25) {
      return "Number of others receiving half their support for tax year " + yr + " must be between 0 and 25.";
   }
   return;
}

function PriorYearFilingStatus(field, rules, i, options) {
   var yr = rules[i + 2];
   var inputText = field.val();
   if ((inputText === undefined) || (inputText === "")) {
      return "Tax Filing Status for tax year " + yr + " is required.";
   }
   return;
}

function PriorYearSeparated(field, rules, i, options) {
   var yr = rules[i + 2];
   var inputText = field.val();

   if ((inputText === undefined) || (inputText === "")) {
      return "Separation from spouse selection for tax year " + yr + " is required.";
   }
   return;
}

function PriorYearAccess(field, rules, i, options) {
   var yr = rules[i + 2];
   var inputText = field.val();

   if ((inputText === undefined) || (inputText === "")) {
      return "Reasonable access to spousal information for tax year " + yr + " is required.";
   }
   return;
}

export function SpouseNoProvide(field, rules, i, options) {
   var inputText = field.val();
   var chkSpouseNoProvideChecked = $("[id$='chkSpouseNoProvide']").is(':checked');
   var error_msg;

   if (!chkSpouseNoProvideChecked) {
      if((field.val() === undefined) || (field.val() === "")) {
         error_msg = "This field is required";
      }
   }

   return error_msg;
}

export function conditionalSpouseAGI(field, rules, i, options) {
   var param1 = rules[i + 2];
   var param2 = rules[i + 3];
   var param3 = rules[i + 4];
   var error_msg;
   var taxFilingField = $('#form1').find("select[id*='" + param1 + "']");
   var separatedFromSpouseField = $('#form1').find("select[id*='" + param2 + "']");
   var reasonableAccessField = $('#form1').find("select[id*='" + param3 + "']");
   var taxFiling = taxFilingField.val();
   var separatedFromSpouse = separatedFromSpouseField.val();
   var reasonableAccess = reasonableAccessField.val();

   if (checkSpouse(taxFiling, separatedFromSpouse, reasonableAccess))  {
      if ((field.val() === undefined) || (field.val() === "")) {
         error_msg = options.custom_error_messages['.valIDRESignSpouseAGI']['required']['message'];
      }
   }
   
   return error_msg;
}

// conditionalMarried returns an error message if the tax filing status indicates the borrower is married
export function conditionalMarried(field, rules, i, options) {
   var param1 = rules[i + 2];    // tax filing status
   var param2 = rules[i + 3];    // which field we are checking
   var error_msg;
   var taxFilingField = $('#form1').find("select[id*='" + param1 + "']");
   var taxFiling = taxFilingField.val();

   if ((taxFiling == "MJ") || (taxFiling == "MS")) {
      if ((field.val() === undefined) || (field.val() === "")) {
         // error message depends on which field we are checking
         if (param2 == "separated")
            error_msg = options.custom_error_messages['.valIDREsignSeparated']['required']['message'];
         else if (param2 == "reasonableAccess")
            error_msg = options.custom_error_messages['.valIDREsignReasonableAccess']['required']['message'];
      }
   }

   return error_msg;
}


// *****************************************************************************
// Buttons
//
// routines for Button click events
//
// ******************************************************************************

export function handleNoValidateButton() {
   $("#form1").validationEngine('detach');
   return true;
}

export function handleNoValidateConfirmButton(message) {
   var consentReturn = confirm(message);
   if (consentReturn) {
      $("#form1").validationEngine('detach');
      return true;
   } else {
      return false;
   }
}

// *****************************************************************************
// eSigns
//
// routines for eSigns
//
// requires two textbox controls, button control with option for checkbox control
// ******************************************************************************

// function used to clear the password input field as well as perform validation
// on the password and optional checkbox agreement controls
export function processESign() {
   // -------------------------------------------------------------------------------
   // verify that the required fields are present to eliminate run time errors
   // -------------------------------------------------------------------------------
   if ($("input[id$='txtSubmission']").length && $("input[id$='txtCC']").length && $("input[id$='btnContinue']").length) {
      // ------------------------------------------------------------------------------
      // we have required fields, start validation
      // ------------------------------------------------------------------------------
      var somewordval = $("input[id$='txtSubmission']").val();
      if (somewordval !== '') {
         $("input[id$='txtCC']").val(somewordval);  // copy it to the hidden field
         $("input[id$='txtSubmission']").val('');   // clear out the password field
         // ---------------------------------------------------------------------------------------------
         // a password value was entered, copy it to hidden field used by the code behind for validation 
         // and clear the field so that IE will not ask the user if they want to save the password
         // ---------------------------------------------------------------------------------------------
         $("input[id$='txtSubmission']").validationEngine('hide');
         $("input[id$='btnContinue']").validationEngine('hide');

         if ($("[id$='cbAgree']").length) {
            // --------------------------------------------------------
            //  we have optional checkbox, validate that it is checked
            // --------------------------------------------------------
            if ($("[id$='cbAgree']").is(':checked')) {
               return true;
            } else {
               $("[id$='cbAgree']").validationEngine('showPrompt', 'You must click the checkbox to indicate that you agree with this submission.', 'error', 'topLeft', true);
               $('html, body').animate({ scrollTop: $("[id$='cbAgree']").offset().top - 75 }, 125);
               return false;
            }
         }
         hideFieldErrorPrompt()
         return true;
      } else {
         $("input[id$='txtSubmission']").validationEngine('showPrompt', 'You must enter your web account password.', 'error', 'topLeft', true);
         $('html, body').animate({ scrollTop: $("input[id$='txtSubmission']").offset().top - 75 }, 125);
          $("input[id$='btnContinue']").validationEngine('showPrompt', 'You must enter your web account password to continue.', 'specialError', 'topLeft', false);
         return false;
      }
   }
}

/* exported processESignCustom */
export function processESignCustom() {
   var signature = $("input[id$='txtBorrowerSignature']");
   var signatureVal = signature.val();
   var submission = $("input[id$='txtSubmission']");
   var submissionVal = submission.val();
   var cc = $("input[id$='txtCC']");
   var ccVal = cc.val();
   var agreeCheckBox = $("[id$='cbAgree']");

   // -------------------------------------------------------------------------------
   // verify that the required fields are present to eliminate run time errors
   // -------------------------------------------------------------------------------
   if (signature.length && submission.length && cc.length) {
      // ------------------------------------------------------------------------------
      // we have required fields, start validation
      // ------------------------------------------------------------------------------
      if (signatureVal !== '' && submissionVal !== '') {
         // ---------------------------------------------------------------------------------------------
         // validate the signature value, it must be first and last name
         // ---------------------------------------------------------------------------------------------
         signatureVal.trim();
         var NameRegex = /^([\w'\.\-]+)(\s)([\w'\.\-]+\s*)+$/;
         var regexResult = NameRegex.test(signatureVal);
         if (regexResult == false)
         {
            signature.validationEngine('showPrompt', 'The name must be both first and last name.<br />&nbsp;&nbsp;&nbsp;Ex.: John Smith' , 'error', 'topLeft', true);
            return false;
         }
         // ---------------------------------------------------------------------------------------------
         // a password value was entered, copy it to hidden field used by the code behind for validation 
         // and clear the field so that IE will not ask the user if they want to save the password
         // ---------------------------------------------------------------------------------------------
         cc.val(submissionVal);  // copy it to the hidden field
         submission.val('');   // clear out the password field

         if (agreeCheckBox.length) {
            // --------------------------------------------------------
            //  we have optional checkbox, validate that it is checked
            // --------------------------------------------------------
            if (agreeCheckBox.is(':checked')) {
               return true;
            } else {
               agreeCheckBox.validationEngine('showPrompt', 'You must click the checkbox to indicate that you agree with this submission.', 'error', 'topLeft', true);
               return false;
            }
         }
         return true;
      } else {
         // something didn't validate so display any bubbles that need to be displayed.  
         // signature field
         if  (! signatureVal.length) {
             signature.validationEngine('showPrompt', 'Legal name as signature is required.', 'error', 'topLeft', true);
         } else {
            signature.validationEngine('hide');
         }
         // submission field
         if (! submissionVal.length) {
             submission.validationEngine('showPrompt', 'You must enter your web account password.', 'error', 'topLeft', true);
         } else {
            submission.validationEngine('hide');
         }
         // agree checkbox
         if (agreeCheckBox.length) {
            // --------------------------------------------------------
            //  we have optional checkbox, validate that it is checked
            // --------------------------------------------------------
            if (! agreeCheckBox.is(':checked')) {
               agreeCheckBox.validationEngine('showPrompt', 'You must click the checkbox to indicate that you agree with this submission.', 'error', 'topLeft', true);
            }
         }
         return false;
      }
   }
}

/* exported processUnemSelection */
function processUnemSelection() {
   // -------------------------------------------------------------------------------
   // verify that the required fields are present to eliminate run time errors
   // -------------------------------------------------------------------------------
   isPageValid();

   if ($("input[id$='rdbSeekEmplmnt']").length && $("input[id$='rdbEligForUnempl']").length) {
      // ------------------------------------------
      // we have required fields, start validation
      // ------------------------------------------
      var hasError = false;
      $("input[id$='rdbSeekEmplmnt']").validationEngine('hide');
      $("input[id$='rdbEligForUnempl']").validationEngine('hide');
      // see what radio button is selected
      if ($("input[id$='rdbSeekEmplmnt']").is(':checked') || $("input[id$='rdbEligForUnempl']").is(':checked')) {
         hideFieldErrorPrompt();
         hasError = true;
      } else {
         $("input[id$='rdbSeekEmplmnt']").validationEngine('showPrompt', 'This field is required. Please select one of the options.', 'error', 'topLeft', true);
         hasError = false;
      }

      return hasError;
   }
}

/* Auto Debit Requests (Esigns) */

export function processADRS2(bCheckFlag) {
   // ----------------------------------------------
   // Verify esign step 2 
   // ----------------------------------------------
   var passes = true;
   var checkedBoxes = 0;

   // -------------------------------------------------------
   // isPageValid validates the required fields on the page
   // -------------------------------------------------------
   if (isPageValid()) {
      if (bCheckFlag === true)   // verify checkbox settings if true
      {
         // --------------------------------------------------------------------------
         // required fields are good to go, now check for too many checked checkboxes
         // --------------------------------------------------------------------------
         if ($("[id$='chkFFELPOpt']").is(':checked')) {
            checkedBoxes = checkedBoxes + 1;
         }
         if ($("[id$='chkCASHOpt']").is(':checked')) {
            checkedBoxes = checkedBoxes + 1;
         }
         if ($("[id$='chkBOTHOpt']").is(':checked')) {
            checkedBoxes = checkedBoxes + 1;
         }
         if (checkedBoxes > 1) {
            $("[id$='chkFFELPOpt']").validationEngine('showPrompt', 'Only one checkbox can be checked.', 'error', 'topLeft', true);
            passes = false;
         }
         if (checkedBoxes < 1) {
            $("[id$='chkFFELPOpt']").validationEngine('showPrompt', 'One checkbox must be checked.', 'error', 'topLeft', true);
            passes = false;
         }
      }
   } else {
     passes = false;
   }

   return passes;
}

// *****************************************************************************
// Misc
//
// Miscellaneous collection of helper routines
//
// ******************************************************************************

// used to show a prompt - ex: code behind message of successful or failed operation

// Can be called to hide all the prompts on a page
export function hide_Error_Prompts() {
   $('#form1').validationEngine('hideAll');
}

// can be called to hide a field's prompt on a page
export function hideFieldErrorPrompt(id) {
   $("[id$='" + id + "']").validationEngine('hide');
}

// Can be called to validate a page and return whether valid
export function isPageValid() {
   return $("#form1").validationEngine('validate');
}

// used to see if a field has an error on it (assumes validation has been run)
function isFieldInvalid(theField) {
   var fieldInvalid = $('#form1').validationEngine('isFieldInvalid', theField);

   return fieldInvalid;
}

// clear the page
export function clearFormData() {
   // reset the form
   $("#form1")[0].reset();
   //   $("select").selectBox("refresh");
   $("select option:selected").prop("selected", false);
   $("select option:first").prop("selected", "selected");

   // hide the error prompts
   $('#form1').validationEngine('hideAll');

   return false;
}

function getClass(element, startsWith) {
   var result = undefined;

   $(element.attr('class').split(" ")).each(function () {
      if (this.indexOf(startsWith) > -1) result = this;
   });

   return result;
}

function linkedValidate(field, rules, i, options) {
   var linkedId = rules[i + 2];

   // validate linked field
   $("input[id*='" + linkedId + "']").validationEngine('validate');
}

function linkedChecked(field, rules, i, options) {
   var linkedId = rules[i + 2];

   // if field is not checked then hide validation on linked field
   if (!field.is(":checked")) {
      $("input[id*='" + linkedId + "']").validationEngine('hide');
   }

}

export function validateSSN(field, rules, i, options) {
  var mySSNRaw = field.val();
  var mySSN
  var error_msg;
  var IsError = false;
  var validArea, validGroup, validSerial;
  var myArea, myGroup, mySerial;
  var error_msg_text = "The SSN is invalid. A valid SSN is 9 numeric digits.<br />It may be entered with or without dashes.";

  mySSN = mySSNRaw.replaceAll("-", "");
  myArea = parseInt(mySSN.substring(0, 3), 10);
  myGroup = parseInt(mySSN.substring(3, 5), 10);
  mySerial = parseInt(mySSN.substring(5, 9), 10);

  // SSN validation
  // Valid SSN:  Area 001-665, 667-899     Group 01-99     Serial 0001-9999
  if ((((myArea >= 1) && (myArea <= 665)) || ((myArea >= 667) && (myArea <= 899))) &&
    (myGroup >= 1) && (myGroup <= 99) &&
    (mySerial >= 1) && (mySerial <= 9999)) {
    // invalid if all numbers are the same of if 123456789 or 234567890
    if ((mySSN === "111111111") || (mySSN === "222222222") || (mySSN === "333333333") || (mySSN === "444444444") ||
      (mySSN === "555555555") || (mySSN === "666666666") || (mySSN === "777777777") || (mySSN === "888888888") ||
      (mySSN === "123456789") || (mySSN === "234567890")) {
      return error_msg_text;  // return error message text
    } else {
      return error_msg;  // returns nothing = no error
    }
  }

  // ITIN validation
  // Valid ITIN:   Area 900-999     Group 50-65,70-88, 90-92, 94-99      Serial 0000-9999
  if ((myArea >= 900) && (myArea <= 999) &&
    (((myGroup >= 50) && (myGroup <= 65)) || ((myGroup >= 70) && (myGroup <= 88)) || ((myGroup >= 90) && (myGroup <= 92)) || ((myGroup >= 94) && (myGroup <= 99))) &&
    (mySerial >= 0) && (mySerial <= 9999)) {
      return error_msg;   // returns nothing = no error
  }

  // ATIN validation
  // Valid ATIN:   Area 900-999     Group 93     Serial 0000-9999
  if ((myArea >= 900) && (myArea <= 999) &&
    (myGroup === 93) &&
    (mySerial >= 0) && (mySerial <= 9999)) {
    return error_msg;   // returns nothing = no error
  }

  return error_msg_text;  // if any were valid they should have returned so if we're this far then return the error message text.
}
